export const COMPONENT_NAMES = {
    LOCATION_TREE: 'location-tree',
    MANAGE_LOCATION_TREE: 'manage-location-tree',
    CATALOG_TREE: 'catalog-tree',
    MANAGE_CATALOG_TREE: 'manage-catalog-tree',
    SELECT_LOCATION_TREE: 'select-location-tree'
};